theme.loadImageSection = function(container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    container.classList.remove('loading', 'loading--delayed');
    container.classList.add('loaded');
    
    setTimeout(function(){
      $(".hero__animation-contents").css("display", "block");
    }, 400);
  }

  function checkForLazyloadedImage() {
    return container.querySelector('.lazyloaded');
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if (container.querySelector('svg')) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage()) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage()) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 25);
};